const dismissableContainers = document.querySelectorAll('.js-element--dismissContainer');

dismissableContainers.forEach((dismissContainer) => {
    const dismissElement = dismissContainer.querySelector('.js-element--dismissAction');
    const dismissID = dismissContainer.getAttribute('dismiss-id');

    if (localStorage.getItem(dismissID) === 'true' ) {
        dismissContainer.remove();
        return;
    }

    dismissContainer.classList.remove('isHidden');

    dismissElement.addEventListener('click', () => {
        localStorage.setItem(dismissID, true);
        dismissContainer.remove();
    });
});